import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BedDouble = t0 => {
  const $ = _c(11);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="m2.56006 2.87992v4.8h10.88004v-4.8c0-.53019-.4298-.96-.96-.96h-.128-8.70404-.128c-.53019 0-.96.42981-.96.96z" />;
    t2 = <path d="m1.27979 8.53326v4.26664h13.44001v-4.26664c0-.47128-.3821-.85333-.8533-.85333h-.4907-10.75201-.49067c-.47128 0-.85333.38205-.85333.85333z" />;
    t3 = <path d="m1.27979 10.8799h13.44001" />;
    t4 = <path d="m4.47998 5.54678v2.13334h2.56v-2.13334-.17066c0-.14139-.11461-.256-.256-.256h-2.048c-.14138 0-.256.11461-.256.256z" />;
    t5 = <path d="m8.95996 5.54678v2.13334h2.56004v-2.13334-.17066c0-.14139-.1147-.256-.256-.256h-2.04804c-.14138 0-.256.11461-.256.256z" />;
    t6 = <path d="m1.27979 14.4v-1.6h1.91999v1.6.128c0 .106-.08596.192-.19199.192h-1.536c-.10604 0-.192-.086-.192-.192z" />;
    t7 = <path d="m12.7998 14.4v-1.6h1.92v1.6.128c0 .106-.086.192-.192.192h-1.536c-.106 0-.192-.086-.192-.192z" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== props) {
    t8 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16" strokeWidth={0.9}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}</IconWrapper>;
    $[9] = props;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
export { BedDouble };